import { navigate } from '../lib/router';

export function BackLink({ to, label }: { to: string; label: string }) {
  return (
    <a
      href={to}
      onClick={(e: MouseEvent) => { e.preventDefault(); navigate(to); }}
      class="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-slate-200 transition-colors mb-4"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
      </svg>
      {label}
    </a>
  );
}
